module.exports = __webpack_public_path__ + "images/ai_recommendations/search_plus-27819fd9e05632af7cd86ecf3bf37d66.svg";